import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/homePage'
import DetailPage from '@/views/detailPage'
import PdetailPage from '@/views/PdetailPage'

import detail from '../views/detail/index.vue'
Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'HomePage', component: HomePage, meta: { title: '全球华人导师科研' } },
  { path: '/detailPage', name: 'DetailPage', component: DetailPage, meta: { title: '全球华人导师科研' } },
  { path: '/PdetailPage', name: 'PdetailPage', component: PdetailPage, meta: { title: '全球华人导师科研' } },
  { path: '/detail', name: 'detail', component: detail, meta: { title: '海报' } },
  { path: '*', redirect: { name: 'HomePage' } }
]

const router = new VueRouter({ mode: 'history', routes })
router.beforeEach((to, from, next) => {
  // 获取用户代理信息
  const userAgent = navigator.userAgent.toLowerCase()
  console.log(userAgent)
  // 判断是否在微信小程序中打开
  if (userAgent.indexOf('miniprogram') !== -1) {
    // 如果在小程序中打开，则修改路由的标题为小程序的标题
    document.title = '集思未来科研项目'
    // 继续路由跳转
    next()
  } else {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta ? to.meta.title : '全球华人导师科研'
    }
    next()
  }
})
export default router
